import { useDispatch } from 'dva';
import React, { useEffect, useState } from 'react';
import { ISurveyHook } from '../../../utils/Survey/SurveyHook';
import AuthCompount from './../../AuthCompount/AuthCompount';
import './FormDoubleNumInput.scss';
const isPc = window.screen.width > 500;
/**
 * 数字输入框
 * 在subjectData里面type为inputNumber
 * 根据sections 判断是否有 有箭头
 */
function FormNumInput(props: ISurveyHook) {
  const formObj = props.formObj.subjectData;
  const [inputVal, setInputVal] = useState('');
  const [inputVal2, setInputVal2] = useState('');
  const dispatch = useDispatch();
  function inputChange1(str: React.ChangeEvent<HTMLInputElement>) {
    setInputVal(str.currentTarget.value);
  }
  function inputChange2(str: React.ChangeEvent<HTMLInputElement>) {
    setInputVal2(str.currentTarget.value);
  }

  useEffect(() => {
    dispatch({
      type: 'survey/changeForm',
      payload: {
        props,
        val: inputVal && inputVal2 ? `${inputVal}/${inputVal2}` : '',
      },
    });
  }, [inputVal, inputVal2]);
  return (
    <div id="FormNumInput">
      <div className="form_box">
        <div className="form_box_content">
          <div className="tit_box">
            <AuthCompount
              // tslint:disable-next-line:jsx-no-multiline-js
              isShow={!!props.formObj.validatorData.required}
            >
              <div
                id={formObj.parentPosition && `errLogo_${formObj.field}_${formObj.parentPosition.groupIndex}`}
                className={formObj.errMsg ? 'cl star' : 'star'}
              >
                *
              </div>
            </AuthCompount>
            <div>{formObj.subjectName}</div>
          </div>

          <div className="ipt_box">
            <input
              className={`form_input1 form_input`}
              // tslint:disable-next-line:jsx-no-multiline-js
              defaultValue={!formObj.defaultValue ? '' : String(formObj.defaultValue).split('/')[0]}
              onChange={inputChange1}
              id={props.formObj.subjectData.field}
              type="number"
              placeholder={formObj.placeholder}
            />
            <div className="scale">/&nbsp;</div>
            <input
              className={`form_input1 form_input`}
              // tslint:disable-next-line:jsx-no-multiline-js
              defaultValue={!formObj.defaultValue ? '' : String(formObj.defaultValue).split('/')[1]}
              onChange={inputChange2}
              id={props.formObj.subjectData.field}
              type="number"
              placeholder={formObj.placeholder}
            />
            <div className="scale">{formObj.unit}</div>
          </div>
        </div>
        <AuthCompount isShow={!!formObj.explain}>
          <div className="explain">（说明：{formObj.explain}）</div>
        </AuthCompount>
        <AuthCompount isShow={isPc}>
          <div
            className="errMsg"
            id={formObj.parentPosition && `${formObj.field}_${formObj.parentPosition.groupIndex}`}
          >
            {formObj.errMsg}
          </div>
        </AuthCompount>
      </div>
      <AuthCompount isShow={!isPc}>
        <div
          className="m_errMsg"
          id={formObj.parentPosition && `${formObj.field}_${formObj.parentPosition.groupIndex}`}
        >
          {formObj.errMsg}
        </div>
      </AuthCompount>
    </div>
  );
}
export default React.memo(FormNumInput);
